import React, { FC } from 'react';
import StyledBox from 'views/rebranded-module/events-module/MotorcycleEventsDetailsView/components/EventInformationSection/EventInformationSection.styles';
import { Typography700 } from 'views/rebranded-module/common/components';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import Typography500 from 'views/common/components/UI/Typography500';
import { Box } from '@mui/material';
import { RiCalendar2Fill, RiMapPin2Line } from 'react-icons/ri';
import { EventTitleSectionProps } from 'views/rebranded-module/events-module/MotorcycleEventsDetailsView/components/EventInformationSection/EventInformationSection.types';

const EventInformationSection: FC<EventTitleSectionProps> = (props) => {
  const { adress, startDate, endDate, description } = props;
  const content = useContent('EventDetailsPage');

  return (
    <StyledBox>
      <Typography700 variant="h5" component="p" mb={2.5}>
        {content.aboutEventTitle}
      </Typography700>
      <Box className="EInfoItem" mb={1}>
        <RiCalendar2Fill className="EInfoIcon" />
        <Typography500 variant="body2" component="p">
          {startDate} - {endDate}
        </Typography500>
      </Box>
      <Box className="EInfoItem">
        <RiMapPin2Line className="EInfoIcon" />
        <Typography500 variant="body2" component="p">
          {adress}
        </Typography500>
      </Box>
      <Typography500
        variant="body1"
        component="p"
        color="text.secondary"
        mt={3}
        className="EISDesc"
        dangerouslySetInnerHTML={{ __html: description }}
      />
   
    </StyledBox>
  );
};

export { EventInformationSection };
